import { render, staticRenderFns } from "./List.vue?vue&type=template&id=26dc9920&"
import script from "../../models/ticket-order-management/list.ts?vue&type=script&lang=ts&"
export * from "../../models/ticket-order-management/list.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports